import { studentProfileState } from "./atom";

export default {
  studentProfileState,
};
